import { render, staticRenderFns } from "./ConfigViewerAddress.vue?vue&type=template&id=e55246fe"
import script from "./ConfigViewerAddress.vue?vue&type=script&lang=js"
export * from "./ConfigViewerAddress.vue?vue&type=script&lang=js"
import style0 from "./ConfigViewerAddress.vue?vue&type=style&index=0&id=e55246fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports